import getWindowUrl from './getWindowUrl.mjs';

const PREFIX_REGEX = /^https?:\/\/[^/]+(\/fr)?/;

const getOriginWithPrefix = (requestUrl) => {
  const url = requestUrl || getWindowUrl();
  const [originWithPrefix = 'https://fashionunited.ie'] = url.match(PREFIX_REGEX) || [];
  return originWithPrefix;
};

export default getOriginWithPrefix;
